import { base } from './';
const PATH = '/contents-files';

const getFiles = (id: string) => {
  return base.get(`${PATH}/${id}`);
};

const upload = ({ id, file }: { id: string; file: File }) => {
  const formData = new FormData();
  const newFile = new File([file], `${id}.json`, {
    type: 'application/json',
  });
  formData.append('file', newFile);
  const isDev = process.env.REACT_APP_ENV === 'dev';
  const directory = isDev ? 'contents/dev' : 'contents';
  formData.append('directory', directory);

  return base.post(`${PATH}/${id}`, formData);
};

const deleteFile = (fileId: string) => {
  return base.delete(`${PATH}/${fileId}`);
};

export { getFiles, upload, deleteFile };
